import moment from 'moment';
import { format2Digit } from 'helper/helper';

const monthL = 'month';
const yearL = 'year';

export const getFirstWkMonth = (month, year) => {
	return moment().clone().set(monthL, month).set(yearL, year).startOf(monthL);
};

export const getLastWkMonth = (month, year) => {
	return moment().clone().set(monthL, month).set(yearL, year).endOf(monthL);
};

export const getFirstWeekNumberYearBased = (year, month) => {
	return moment().clone().set(yearL, year).set(monthL, month).startOf(monthL);
};

export const printWeekDays = (pMonth, pYear, minWk, wkCount = 1, wkWeeks = []) => {
	const currMonth = moment().clone().set(monthL, pMonth).set(yearL, pYear);
	const currYear = currMonth.year();
	const tyFirstWMWeek = getFirstWeekNumberYearBased(currYear, 1);
	const lyFirstWMWeek = getFirstWeekNumberYearBased(currYear - 1, 1);
	const firstWeekOfTheMonth = getFirstWkMonth(pMonth, currYear);
	const lastDayIndex = moment().set(monthL, pMonth).set(yearL, currYear).endOf(monthL).day();
	const prevMonthLastWeekNumber = getLastWkMonth(pMonth - 1, currYear);
	const lastWeekOfTheMonth = getLastWkMonth(pMonth, currYear);
	let wk = 1;
	let yr = currYear;

	if (currMonth.month() === 0) {
		let wmWeekNumber = 1;
		if (lastDayIndex === 5) {
			wmWeekNumber = 0;
		}
		if (firstWeekOfTheMonth.week() >= 52) {
			let count = 0;
			while (count <= lastWeekOfTheMonth.week() - wmWeekNumber) {
				wk = firstWeekOfTheMonth.week() - (lyFirstWMWeek.week() - 1) + count;
				yr = currYear - 1;
				const formatedWK = Number(`${yr}${format2Digit.format(wk)}`);
				if (minWk <= formatedWK) {
					wkWeeks.push(formatedWK);
				}
				count++;
			}
		} else {
			let count = firstWeekOfTheMonth.week();
			while (count <= lastWeekOfTheMonth.week() - wmWeekNumber) {
				wk = prevMonthLastWeekNumber.week() - (lyFirstWMWeek.week() - 1) + count;
				yr = currYear - 1;
				const formatedWK = Number(`${yr}${format2Digit.format(wk)}`);
				if (minWk <= formatedWK) {
					wkWeeks.push(formatedWK);
				}
				count++;
			}
		}
		if (wmWeekNumber === 1) {
			wk = 1;
			yr = currYear;
			const formatedWK = Number(`${yr}${format2Digit.format(wk)}`);
			if (minWk <= formatedWK) {
				wkWeeks.push(formatedWK);
			}
		}
	} else {
		for (let i = firstWeekOfTheMonth.week(); i <= lastWeekOfTheMonth.week(); i++) {
			wk = i - (tyFirstWMWeek.week() - 1);
			yr = currYear;
			const formatedWK = Number(`${yr}${format2Digit.format(wk)}`);
			if (minWk <= formatedWK) {
				wkWeeks.push(formatedWK);
			}
		}
	}

	// below 3 is just a random number. Just want to have few extra weeks in the list
	if (wkWeeks.length < wkCount + 3) {
		if (pMonth === 11) {
			pYear += 1;
		}
		printWeekDays(pMonth + 1, pYear, minWk, wkCount, wkWeeks);
	}

	if (wkCount === 0) {
		return `${wkWeeks[0]}`;
	} else if (wkCount === 1) {
		return `${wkWeeks[1]}`;
	}
	const uniqList = [...new Set(wkWeeks)];
	return uniqList.slice(1, wkCount + 1).join(',');
};
